jQuery(document).ready(function($) {
  // // Setup GTM Datalayer
  // window.dataLayer = window.dataLayer || []

  // Popup contact forms
  $('#contact form.form__contact').each(function() {
    $(this).on('submit', function(e) {
      e.preventDefault()
      var $form = $(this)
      var formButton = $form.find('button')
      var messageBox = $form.find('div.callout p')
      var formType = $form.find('#contact-type').val()
      var formDevelopment = $form.find('#contact-development').val()
      formButton.attr('disabled', true)
      formButton.addClass('warning')
      formButton.html('Submitting...')
      $.post(
        $form.attr('action'),
        $form.serialize(),
        function(data) {
          formButton.removeClass('warning')
          if (!data.error) {
            formButton.attr('disabled', true)
            formButton.addClass('success')
            formButton.html('Submitted')
            $form.addClass('hide')
            $('#form-success').removeClass('hide')
            $('#form-success p').html('Thank you for submitting your details.')
            $.event.trigger({
              type: 'harronFormSubmit',
              contactType: formType,
              development: formDevelopment,
              time: new Date(),
            })
          } else {
            $form.find('div.callout').removeClass('hide')
            messageBox.html(data.error_message)
            formButton.attr('disabled', false)
            formButton.html('Submit')
            $.event.trigger({
              type: 'harronFormSubmitFail',
              contactType: formType,
              development: formDevelopment,
              time: new Date(),
            })
          }
        },
        'json'
      ).fail(function() {
        formButton.removeClass('warning')
        formButton.attr('disabled', false)
        formButton.html('Submit')
        $.event.trigger({
          type: 'harronFormSubmitFail',
          contactType: formType,
          development: formDevelopment,
          time: new Date(),
        })
      })
    })
  })

  // Contact us development dropdown submit
  if ($('form#contact-development').length > 0) {
    var $form = $('form#contact-development')
    $form.find('select').each(function() {
      $(this).change(function() {
        $form.submit()
      })
    })

    $form.on('submit', function(e) {
      e.preventDefault()
      var selected = $(this)
        .find(':selected')
        .data('developmentId')
      if (selected) {
        // It has some data, let's do the AJAX request
        $('#contact-loader').removeClass('hide')
        $.post(
          $form.attr('action'),
          $form.serialize(),
          function(data) {
            if (!data.error) {
              $('#contact-loader').addClass('hide')
              swapDevelopmentData(data)
            } else {
              $('#contact-loader').addClass('hide')
              console.log('There are errors on the form')
            }
          },
          'json'
        ).fail(function() {
          $('#contact-loader').addClass('hide')
          console.log('The form has failed to submit')
        })
      }
    })

    function swapDevelopmentData(data) {
      // Select the form
      $contactForm = $('.development__contact-form .gform_wrapper form')

      // Reset form
      $contactForm[0].reset()

      // Populate the hidden input with development ID
      $contactForm.find('#field_7_24 input').val(data.post.ID)

      // Populate the hidden input with contact type
      $contactForm
        .find('#field_7_28 select')
        .val('register_development')
        .change()

      // Set details about property to sell to hidden
      $contactForm.find('#field_7_15').css('display', 'none')

      // Add status dropdown event listener
      $('select[name="input_8"]').on('change', function() {
        // Handle the status change
        var newStatus = $(this).val()

        if (newStatus == 'Property to sell') {
          $('#field_7_15').css('display', 'block')
        } else {
          $('#field_7_15').css('display', 'none')
        }
      })

      $('.development__streetscene').html(data.streetscene)
      $('.development__logo').html(data.logo)
      if (data.status == 'unreleased') {
        $('.development__link').addClass('hide')
      } else {
        $('.development__link').removeClass('hide')
        $('.development__link a').attr('href', data.permalink)
      }
      $('.development__telephone a').attr('href', 'tel:' + data.telephone)
      $('.development__telephone a').text('Tel: ' + data.telephonenice)
      $('.development__address').html(data.address)
      $('.development__opening-times').html(data.openingtimes)
      $('.development__description').html(data.description)
      $('.development__key-info').html(data.keyinfo)
      $('.section__development').removeClass('hide')
      Foundation.SmoothScroll.scrollToLoc('#development-info-container', {
        threshold: 50,
        offset: 50,
      })
    }
  }
})
